import script from "./ExternalLoginView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalLoginView.vue?vue&type=script&setup=true&lang=js"

import "./ExternalLoginView.vue?vue&type=style&index=0&id=728dea25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-728dea25"]])

export default __exports__